import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { BasePrice } from 'b2b-components/theme/components/BasePrice';
import { HIDDEN_PRICE_DISPLAY_TYPE, HiddenPrice } from 'b2b-apps/shop/common/components/HiddenPrice/HiddenPrice';
import { Price } from 'b2b-apps/shop/product/components/ProductData/PriceList/Price';
import { SecondaryPrices } from 'b2b-apps/shop/product/components/ProductData/PriceList/SecondaryPrices';
import { usePricesTexts } from 'b2b-apps/shop/product/hooks';
import { getProductSecondaryPrices } from 'b2b-apps/shop/product/utils/getProductSecondaryPrices';
import { Props } from './index';
import './PriceList.scss';

const PriceList = ({ effectivePricing, className }: Props): ReactElement => {
  const {
    basePrice,
    priceTaxRate,
    isHiddenPrice,
    isHiddenPriceAndNotCertified,
  } = effectivePricing;
  const text = usePricesTexts(priceTaxRate);
  const prices = getProductSecondaryPrices({ effectivePricing, text });

  const rootClassName = classNames(
    'PriceList',
    {
      'PriceList--WithBasePrice': basePrice,
    },
    className,
  );

  if (isHiddenPrice) {
    return (
      <HiddenPrice
        className="PriceList-HiddenPrice"
        displayType={HIDDEN_PRICE_DISPLAY_TYPE.full}
        isHiddenPriceAndNotCertified={isHiddenPriceAndNotCertified}
      />
    );
  }

  const { price, tax } = prices.userPriceWithoutVat || prices.listPrice;

  return (
    <div className={rootClassName}>
      <div className="PriceList-MainPrice">
        <Price
          price={price}
          tax={tax}
          isSecondary={false}
        />
      </div>

      {basePrice && (
        <div className="PriceList-BasePrice">
          <BasePrice
            unit={basePrice.unit}
            price={basePrice.price}
            currency={'CHF'}
          />
        </div>
      )}

      <SecondaryPrices
        prices={prices}
      />
    </div>
  );
};

export { PriceList };
